export default {
  PUBLIC: "Pubic Account",
  SCHOOL_BASED_TEACHER: "School-based Teacher Account",
  INDIVIDUAL_TEACHER: "Individual Teacher Account",
  STUDENT: "Student Account",
  SCHOOL_ADMINISTRATOR: "School Administrator Account",
  SCHOOL: "School Staff Account",
  CORPORATE_ADMINISTRATOR: "Corporate Administrator Account",
  OTHER: "Others",
  STUDENT_MEMBER:"Student Member",
  FULL_MEMBER:"Member",
  SCHOOL_PURCHASER:"School Buyer Account",
};
